export const buildPortalUrl = (path) => {
  const baseUrl = import.meta.env.VITE_PORTAL_URL.replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");

  return `${baseUrl}/${normalizedPath}`;
};
